import React from 'react';
import TemplateImage from './TemplateImage';
import findSize from '../../utils/findSize';
import { Sizes } from '../../utils/types';

// a height or width should be specified for each image
// and corresponding maximum for rows and columns where possible

type DisplayLayoutProps = {
  sizes: Sizes;
};

export default function DisplayLayout({ sizes }: DisplayLayoutProps) {
  return (
    <div className="select-none overflow-hidden p-8">
      <div className="mx-auto flex w-full flex-col items-end gap-4 overflow-hidden">
        <div className="flex flex-row items-end gap-4">
          <TemplateImage size={findSize(sizes, 160, 600)} height={500} />
          <TemplateImage size={findSize(sizes, 120, 600)} height={500} />
          <div className="flex max-h-[500px] max-w-[300px] flex-col items-start gap-4">
            <TemplateImage size={findSize(sizes, 250, 250)} width={275} />
            <TemplateImage size={findSize(sizes, 300, 250)} width={275} />
          </div>
        </div>
        <TemplateImage size={findSize(sizes, 930, 180)} width={425} />
      </div>
    </div>
  );
}
